import ApiClient from '@/api/ApiClient';
import LessonAnswer from '@/api/models/LessonAnswer';

class CourseVideoLessonService {
    #prefixUrl = 'api/lesson/';

    constructor() {
        this.api = new ApiClient(this.#prefixUrl);
    }

    /**
     * Updates course video status
     * @param {integer} lessonAnswerId
     * @param {integer} lessonId
     * @return {Response}
     */
    async checkLessonAnswer(lessonAnswerId = null, lessonId = null) {
        const response = await this.api.executeRequest(`/check/${lessonAnswerId}`, { lessonId: lessonId }, this.api.methods.POST);
        if (response.success())
            response.setContent(new LessonAnswer(response.getContent()));
        return response;
    }

    /**
     * Get number of remaining attemps of the User to answer a question 
     * @param {*} lessonAnswerId 
     * @param {*} lessonId 
     * @returns {Response}
     */
    async getRemainingNumberOfAttempts(lessonAnswerId = null, lessonId = null) {
        const response = await this.api.executeRequest(`/attempts/${lessonAnswerId}`, { lessonId: lessonId }, this.api.methods.POST);
        if (!response.success())
            return null;
        return response.getContent();
    }

    /**
     * Saves video Lesson by creating or updating
     * Obs: if lessonId is sent, updates video
     * @param {object} lessonData
     * @param {integer} lessonId
     * @returns {api/models/Response}
     */
    async saveLesson(lessonData = {}, lessonId = null) {
        let response = false;

        if (lessonId != null) {
            response = await this.api.executeRequest(`/${lessonId}`, lessonData, this.api.methods.PUT);
        } else {
            response = await this.api.executeRequest('/', lessonData, this.api.methods.POST);
        }
        
        return response;
    }

    /**
     * Deletes Lesson
     * @param {integer} id
     * @returns {api/models/Response}
     */
    async deleteLesson(id = null) {
        const response = await this.api.executeRequest(`/${id}`, {}, this.api.methods.DELETE);

        return response;
    }

    /**
     * Gets all Lesson of Video
     * @param {integer} id
     * @returns {api/models/Response}
     */
    async getLessonsByVideo(id = null) {
        const response = await this.api.executeRequest(`/video/${id}`, {}, this.api.methods.GET);

        let content = [];

        if (response.success()) {
            const data = response.getContent();

            for(let moduleId of Object.keys(data)){
                content.push(data[moduleId]);
            }
        }

        response.setContent(content);

        return response;
    }

    /**
     * Gets lessons by Lesson id
     * @param {integer} id 
     * @returns {api/models/Response}
     */
    async getLessonById(id = null) {
        const response = await this.api.executeRequest(`/lesson/${id}`, {}, this.api.methods.GET);

        let data = [];

        if (response.success()) {
            for (let val of response.getContent()) {
                val.correct = val.correct == 1 ? true : false;
                data.push(val);
            }
        }

        response.setContent(data);

        return response;
    }

    /**
     * Removes Lesson
     * @param {integer} video 
     * @returns {api/models/Response}
     */
    async removeVideoLesson(videoId = null) {
        const response = await this.api.executeRequest(`/${videoId}`, {}, this.api.methods.DELETE);

        return response;
    }
}

export default new CourseVideoLessonService();
